<template>
  <v-container>
    <h3>みんなの会話デッキ</h3>
    <Paginator
      @next-page="next()"
      @prev-page="prev()"
      :hasNextPage="hasNextPage"
      :hasPreviousPage="hasPreviousPage"
    />

    <DeckList :decks="decks" @select-deck="selectDeck($event)" />
    <Paginator
      @next-page="next()"
      @prev-page="prev()"
      :hasNextPage="hasNextPage"
      :hasPreviousPage="hasPreviousPage"
    />
  </v-container>
</template>

<script>
// @ is an alias to /src
import DeckList from "@/components/DeckList.vue";
import Paginator from "@/components/Paginator.vue";
import { KaiwaDeck } from "@/models/KaiwaDeck";

import { mapGetters } from "vuex";
import router from "@/router";

export default {
  name: "PublicDecks",
  components: {
    DeckList,
    Paginator,
  },
  computed: {
    ...mapGetters({
      decks: "getPublicDecks",
      hasNextPage: "hasNextPage",
      hasPreviousPage: "hasPreviousPage",
    }),
  },
  created() {
    this.$store.dispatch("fetchNextPublicDecks");
  },
  methods: {
    prev() {
      this.$store.dispatch("fetchPreviousPublicDecks");
    },
    next() {
      this.$store.dispatch("fetchNextPublicDecks");
    },
    selectDeck(deck) {
      router.push({ path: `/decks/${deck.deckId}` });
    },
  },
};
</script>
